import gql from 'graphql-tag'

export default gql`query pcpGetFacilities($name: String, $limit: Int) {
	pcpGetFacilities(name: $name, limit: $limit) {
		id
		name
  }
}`
